'use strict';

Object.defineProperty(exports, "__esModule", {
  value: !0
});

function f(d) {
  return d && "object" === typeof d && "default" in d ? d["default"] : d;
}

var g = f(require("@babel/runtime/helpers/classCallCheck")),
    k = f(require("@babel/runtime/helpers/createClass")),
    l = f(require("@babel/runtime/helpers/possibleConstructorReturn")),
    m = f(require("@babel/runtime/helpers/getPrototypeOf")),
    q = f(require("@babel/runtime/helpers/inherits")),
    r = f(require("@babel/runtime/helpers/assertThisInitialized")),
    t = f(require("@babel/runtime/helpers/defineProperty")),
    u = require("react"),
    v = f(require("@babel/runtime/helpers/slicedToArray")),
    w = f(require("@babel/runtime/helpers/toConsumableArray")),
    x = f(require("@babel/runtime/helpers/objectSpread")),
    y = f(require("@babel/runtime/helpers/extends")),
    z = f(require("hoist-non-react-statics")),
    B = require("@lingui/core"),
    H = u.createContext({
  i18n: {},
  defaultRender: null
}),
    I = H.Provider,
    J = H.Consumer,
    K = function (d) {
  function a(h) {
    g(this, a);
    var b = l(this, m(a).call(this, h));
    t(r(r(b)), "unsubscribe", void 0);
    t(r(r(b)), "setContext", function () {
      var c = {
        context: {
          i18n: b.props.i18n,
          defaultRender: b.props.defaultRender
        }
      };
      (0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : 1) && b.setState(c);
      return c;
    });
    b.state = b.setContext(!1);
    return b;
  }

  q(a, d);
  k(a, [{
    key: "componentDidMount",
    value: function value() {
      this.unsubscribe = this.props.i18n.didActivate(this.setContext);
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      this.unsubscribe();
    }
  }, {
    key: "render",
    value: function value() {
      var a = this.state.context;
      return u.createElement(I, {
        value: a
      }, a.i18n.locale && this.props.children);
    }
  }]);
  return a;
}(u.Component),
    L = /<(\d+)>(.*)<\/\1>|<(\d+)\/>/,
    M = /(?:\r\n|\r|\n)/g;

function N(d) {
  var a = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : [],
      h = d.replace(M, "").split(L);
  if (1 === h.length) return d;
  var b = [],
      c = h.shift();
  c && b.push(c);
  c = !0;
  var A = !1,
      e = void 0;

  try {
    for (var n = O(h)[Symbol.iterator](), C; !(c = (C = n.next()).done); c = !0) {
      var p = v(C.value, 3),
          D = p[0],
          E = p[1],
          F = p[2],
          G = a[D];
      b.push(u.cloneElement(G, {
        key: D
      }, E ? N(E, a) : G.props.children));
      F && b.push(F);
    }
  } catch (R) {
    A = !0, e = R;
  } finally {
    try {
      c || null == n.return || n.return();
    } finally {
      if (A) throw e;
    }
  }

  return b;
}

function O(d) {
  if (!d.length) return [];
  var a = d.slice(0, 4);
  a = v(a, 4);
  var h = a[1],
      b = a[2],
      c = a[3];
  return [[parseInt(a[0] || b), h || "", c]].concat(O(d.slice(4, d.length)));
}

var P = function (d) {
  function a() {
    g(this, a);
    return l(this, m(a).apply(this, arguments));
  }

  q(a, d);
  k(a, [{
    key: "getTranslation",
    value: function value(a) {
      var b = this.props,
          c = b.id;
      c = void 0 === c ? "" : c;
      var d = b.defaults;
      b = b.formats;
      var e = x({}, this.props.values),
          h = this.props.components ? w(this.props.components) : [];
      e && Object.keys(e).forEach(function (a) {
        var c = e[a];
        u.isValidElement(c) && (c = h.push(c) - 1, e[a] = "<".concat(c, "/>"));
      });
      return (a = a && "function" === typeof a._ ? a._(c, e, {
        defaults: d,
        formats: b
      }) : c) ? N(a, h) : null;
    }
  }, {
    key: "render",
    value: function value() {
      var a = this;
      return u.createElement(J, null, function (b) {
        var c = b.defaultRender;
        b = a.getTranslation(b.i18n);
        var d = a.props,
            e = d.render;
        c = void 0 === e ? c : e;
        e = d.id;
        d = d.defaults;
        return null === c || void 0 === c ? b : "string" === typeof c ? u.createElement(c, {}, b) : "function" === typeof c ? c({
          id: e,
          translation: b,
          defaults: d
        }) : u.cloneElement(c, {}, b);
      });
    }
  }]);
  return a;
}(u.Component);

function Q() {
  var d = (0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {}).withHash,
      a = void 0 === d ? !1 : d;
  return function (d) {
    var b = u.forwardRef(function (c, b) {
      return u.createElement(J, null, function (e) {
        e = e.i18n;
        return u.createElement(d, y({}, c, {
          ref: b,
          i18n: e,
          i18nHash: a ? e.locale : void 0
        }));
      });
    });
    return z(b, d);
  };
}

var S = Q(),
    T = Q({
  withHash: !0
});

function U(d) {
  return function (a) {
    var h = a.value,
        b = a.format;
    return u.createElement(J, null, function (a) {
      a = a.i18n;
      return d(a.locales || a.locale, b)(h);
    });
  };
}

var V = U(B.date),
    W = U(B.number);
exports.setupI18n = B.setupI18n;
exports.withI18n = S;
exports.withI18nForPure = T;
exports.I18nProvider = K;
exports.I18n = J;
exports.Trans = P;
exports.DateFormat = V;
exports.NumberFormat = W;